import $http from '@/utils/http'

export function doGet(url) {
    return $http.get(url);
}
export function doPost(url, data) {
    return $http.post(url, data);
}



// 首页-数据看板中间数据
export function centerData() {
	return $http.get('/api/phone/data/centerData')
}

//首页-数据看板左侧数据
export function leftData() {
	return $http.get('/api/phone/data/leftData')
}
//首页-数据看板左侧数据
export function selectWeightCate(type) {
	return $http.get('/api/phone/data/selectWeightCate?type='+type)
}
//首页-数据看板左侧数据
export function selectDetailsAndNewOrder() {
	return $http.get('/api/phone/data/selectDetailsAndNewOrder')
}

//首页-数据看板右侧数据
export function rightDataNew() {
	return $http.get('/api/phone/data/rightDataNew')
}

//首页-数据看板中间数据
export function centerDataNew() {
	return $http.get('/api/phone/data/centerDataNew')
}

// 物流大数据看板***********
// 物流左边数据
export function wlLeftData() {
	return $http.post('https://xcx.31hs.cn/api/phone/logisticsData/leftData')
}
// 物流右边数据
export function wlRightData() {
	return $http.post('https://xcx.31hs.cn/api/phone/logisticsData/rightData')
}

// 物流中间数据
export function wlCenterData() {
	return $http.post('https://xcx.31hs.cn/api/phone/logisticsData/centerData')
}
//分拣红心大数据看板*****
//分拣中心左侧数据

export function fjLeftData(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/siteData/leftData',data)
}
export function fjstatisticsBoardLoss(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/siteData/statisticsBoardLoss',data)
}
export function fjStatisticsCategory(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/siteData/statisticsCategory',data)
}

export function fjCenterData(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/siteData/centerData',data)
}
export function fjRightData(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/siteData/rightData',data)
}
export function fjstatisticsBoardCategory(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/siteData/statisticsBoardCategory',data)
}
export function fjSiteDataTrack(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/siteData/track',data)
}
//平台大数据看板*****
//平台中心左侧数据
// export function ptLeftData(data) {
// 	return $http.post('/phone/api/siteData/leftData',data)
// }
// export function ptstatisticsBoardLoss(data) {
// 	return $http.post('/phone/api/siteData/statisticsBoardLoss',data)
// }

// export function ptCenterData(data) {
// 	return $http.post('/phone/api/siteData/centerData',data)
// }
// export function ptRightData(data) {
// 	return $http.post('/phone/api/siteData/rightData',data)
// }
// export function ptstatisticsBoardCategory(data) {
// 	return $http.post('/phone/api/siteData/statisticsBoardCategory',data)
// }

export function ptLeftData(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/data/leftData',data)
}
export function ptstatisticsBoardLoss(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/data/statisticsBoardLoss',data)
}

export function ptCenterData(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/data/centerData',data)
}
export function ptRightData(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/data/rightData',data)
}
export function ptstatisticsBoardCategory(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/data/statisticsBoardCategory',data)
}
export function ptStatisticsCategory(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/data/statisticsCategory',data)
}
export function ptStatisticsOutSite(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/data/statisticsOutSite',data)
}
export function siteDataStatisticsOutSite(data) {
	return $http.post('https://site.31hs.cn/api/phone/api/siteData/statisticsOutSite',data)
}
